import type { ModuleMigrationDef } from "@kubdee/sdk";

export const migration: ModuleMigrationDef = {
  key: "001_initial",
  version: "0.1.0",
  sql: `
CREATE TABLE IF NOT EXISTS \`connectors_types\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`slug\` text NOT NULL,
	\`name\` text NOT NULL,
	\`icon\` text,
	\`icon_url\` text,
	\`capabilities\` text NOT NULL,
	\`oauth_config\` text,
	\`webhook_config\` text,
	\`is_active\` integer DEFAULT 1 NOT NULL,
	\`created_at\` text NOT NULL,
	\`created_by\` text,
	\`updated_at\` text NOT NULL,
	\`updated_by\` text
);
CREATE UNIQUE INDEX IF NOT EXISTS \`connectors_types_slug_unique\` ON \`connectors_types\` (\`slug\`);
CREATE INDEX IF NOT EXISTS \`connectors_types_is_active_idx\` ON \`connectors_types\` (\`is_active\`);
CREATE TABLE IF NOT EXISTS \`connectors_instances\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`company_id\` text NOT NULL,
	\`type_id\` text NOT NULL,
	\`display_name\` text,
	\`status\` text DEFAULT 'disconnected' NOT NULL,
	\`config\` text,
	\`metadata\` text,
	\`last_sync_at\` text,
	\`last_error\` text,
	\`disabled_reason\` text,
	\`created_at\` text NOT NULL,
	\`created_by\` text,
	\`updated_at\` text NOT NULL,
	\`updated_by\` text,
	\`deleted_at\` text,
	\`deleted_by\` text,
	FOREIGN KEY (\`type_id\`) REFERENCES \`connectors_types\`(\`id\`) ON UPDATE no action ON DELETE no action
);
CREATE INDEX IF NOT EXISTS \`connectors_instances_company_status_idx\` ON \`connectors_instances\` (\`company_id\`, \`status\`);
CREATE INDEX IF NOT EXISTS \`connectors_instances_type_id_idx\` ON \`connectors_instances\` (\`type_id\`);
CREATE INDEX IF NOT EXISTS \`connectors_instances_company_type_idx\` ON \`connectors_instances\` (\`company_id\`, \`type_id\`);
CREATE TABLE IF NOT EXISTS \`connectors_credentials\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`instance_id\` text NOT NULL,
	\`access_token_enc\` text NOT NULL,
	\`refresh_token_enc\` text,
	\`expires_at\` text,
	\`refresh_expires_at\` text,
	\`scope\` text,
	\`token_type\` text DEFAULT 'bearer' NOT NULL,
	\`encryption_key_id\` text NOT NULL,
	\`rotated_at\` text,
	\`created_at\` text NOT NULL,
	\`updated_at\` text NOT NULL,
	FOREIGN KEY (\`instance_id\`) REFERENCES \`connectors_instances\`(\`id\`) ON UPDATE no action ON DELETE cascade
);
CREATE UNIQUE INDEX IF NOT EXISTS \`connectors_credentials_instance_unique\` ON \`connectors_credentials\` (\`instance_id\`);
CREATE INDEX IF NOT EXISTS \`connectors_credentials_expires_at_idx\` ON \`connectors_credentials\` (\`expires_at\`);
CREATE TABLE IF NOT EXISTS \`connectors_oauth_states\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`company_id\` text NOT NULL,
	\`type_id\` text NOT NULL,
	\`state\` text NOT NULL,
	\`code_verifier\` text NOT NULL,
	\`redirect_after\` text,
	\`user_id\` text,
	\`expires_at\` text NOT NULL,
	\`created_at\` text NOT NULL
);
CREATE UNIQUE INDEX IF NOT EXISTS \`connectors_oauth_states_state_unique\` ON \`connectors_oauth_states\` (\`state\`);
CREATE INDEX IF NOT EXISTS \`connectors_oauth_states_expires_at_idx\` ON \`connectors_oauth_states\` (\`expires_at\`);
CREATE INDEX IF NOT EXISTS \`connectors_oauth_states_company_expires_idx\` ON \`connectors_oauth_states\` (\`company_id\`, \`expires_at\`);
CREATE TABLE IF NOT EXISTS \`connectors_webhook_events\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`instance_id\` text NOT NULL,
	\`event_id\` text NOT NULL,
	\`event_type\` text,
	\`signature_valid\` integer DEFAULT 0 NOT NULL,
	\`payload_hash\` text NOT NULL,
	\`payload\` text,
	\`received_at\` text NOT NULL,
	\`processed_at\` text,
	\`processing_status\` text DEFAULT 'pending' NOT NULL,
	\`error\` text,
	\`retry_count\` integer DEFAULT 0 NOT NULL,
	FOREIGN KEY (\`instance_id\`) REFERENCES \`connectors_instances\`(\`id\`) ON UPDATE no action ON DELETE cascade
);
CREATE UNIQUE INDEX IF NOT EXISTS \`connectors_webhook_events_instance_event_unique\` ON \`connectors_webhook_events\` (\`instance_id\`, \`event_id\`);
CREATE INDEX IF NOT EXISTS \`connectors_webhook_events_received_at_idx\` ON \`connectors_webhook_events\` (\`received_at\`);
CREATE INDEX IF NOT EXISTS \`connectors_webhook_events_status_received_idx\` ON \`connectors_webhook_events\` (\`processing_status\`, \`received_at\`);
CREATE TABLE IF NOT EXISTS \`connectors_sync_jobs\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`instance_id\` text NOT NULL,
	\`job_type\` text NOT NULL,
	\`status\` text DEFAULT 'queued' NOT NULL,
	\`scheduled_at\` text NOT NULL,
	\`started_at\` text,
	\`completed_at\` text,
	\`error\` text,
	\`attempts\` integer DEFAULT 0 NOT NULL,
	\`max_attempts\` integer DEFAULT 3 NOT NULL,
	\`payload\` text,
	\`result\` text,
	\`created_at\` text NOT NULL,
	FOREIGN KEY (\`instance_id\`) REFERENCES \`connectors_instances\`(\`id\`) ON UPDATE no action ON DELETE cascade
);
CREATE INDEX IF NOT EXISTS \`connectors_sync_jobs_instance_status_idx\` ON \`connectors_sync_jobs\` (\`instance_id\`, \`status\`);
CREATE INDEX IF NOT EXISTS \`connectors_sync_jobs_status_scheduled_idx\` ON \`connectors_sync_jobs\` (\`status\`, \`scheduled_at\`);
CREATE INDEX IF NOT EXISTS \`connectors_sync_jobs_completed_at_idx\` ON \`connectors_sync_jobs\` (\`completed_at\`);
CREATE INDEX IF NOT EXISTS \`connectors_sync_jobs_instance_type_idx\` ON \`connectors_sync_jobs\` (\`instance_id\`, \`job_type\`);
CREATE TABLE IF NOT EXISTS \`connectors_rate_limits\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`instance_id\` text NOT NULL,
	\`endpoint\` text NOT NULL,
	\`window_start\` text NOT NULL,
	\`window_ms\` integer NOT NULL,
	\`request_count\` integer DEFAULT 0 NOT NULL,
	\`max_per_window\` integer NOT NULL,
	\`updated_at\` text NOT NULL,
	FOREIGN KEY (\`instance_id\`) REFERENCES \`connectors_instances\`(\`id\`) ON UPDATE no action ON DELETE cascade
);
CREATE UNIQUE INDEX IF NOT EXISTS \`connectors_rate_limits_key_unique\` ON \`connectors_rate_limits\` (\`instance_id\`, \`endpoint\`, \`window_start\`);
CREATE INDEX IF NOT EXISTS \`connectors_rate_limits_updated_at_idx\` ON \`connectors_rate_limits\` (\`updated_at\`);
CREATE TABLE IF NOT EXISTS \`connectors_subscriptions\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`instance_id\` text NOT NULL,
	\`module_id\` text NOT NULL,
	\`capability\` text NOT NULL,
	\`event_name\` text NOT NULL,
	\`handler_ref\` text NOT NULL,
	\`active\` integer DEFAULT 1 NOT NULL,
	\`created_at\` text NOT NULL,
	\`created_by\` text,
	\`updated_at\` text NOT NULL,
	\`updated_by\` text,
	FOREIGN KEY (\`instance_id\`) REFERENCES \`connectors_instances\`(\`id\`) ON UPDATE no action ON DELETE cascade
);
CREATE INDEX IF NOT EXISTS \`connectors_subscriptions_instance_cap_active_idx\` ON \`connectors_subscriptions\` (\`instance_id\`, \`capability\`, \`active\`);
CREATE INDEX IF NOT EXISTS \`connectors_subscriptions_module_id_idx\` ON \`connectors_subscriptions\` (\`module_id\`);
  `.trim(),
};
